import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initGlobalErrorHandlers } from "@/lib/logger";

initGlobalErrorHandlers();

createRoot(document.getElementById("root")!).render(<App />);
